import { GroupBase } from "react-select";
// eslint-disable-next-line import/no-unresolved
import { MenuPortalProps } from "react-select/dist/declarations/src/components/Menu";
import { MenuPortalPropsContext } from "./MenuPortalPropsContext";

export function MenuPortal<Option, IsMulti extends boolean, Group extends GroupBase<Option>>
({ children, ...props }: MenuPortalProps<Option, IsMulti, Group>) {
  return (
    <MenuPortalPropsContext.Provider value={props as MenuPortalProps<Option, IsMulti, Group>}>
      {children}
    </MenuPortalPropsContext.Provider>
  );
}